<template>
  <div id="calendar">
    <div class="main-container row">
      <div class="calendar-left col-lg-3" v-if="selected_mode == 'year'">
        <div class="header">
          <div class="font-20px font-weight-600">
            {{$t('calendar_setting')}}
          </div>
        </div>
        <div class="full-width border-top"></div>
        <div class="body body-left" v-if="selected_mode == 'year'">
          <div class="body-left-box">
            <div class="body-left-header">
              <i class="fa fa-angle-left font-weight-600" @click="backMonth"></i>
              <span class="font-weight-600 text-main">{{$t('common.'+full_date.format('MMMM').toLowerCase())}} - {{full_date.format('YYYY')}}</span>
              <i class="fa fa-angle-right font-weight-600" @click="nextMonth"></i>
            </div>
            <calendar-month-min :events="[]" :full_date="full_date" @setFullDate="setFullDate" :today="true" today-color="#0091ff"></calendar-month-min>
          </div>
          <div class="body-left-legend">
            <div class="body-left-legend-title mt-20px pl-20px">
              {{$t('calendar.categories')}}
            </div>
            <div class="body-left-legend-body pl-20px">
              <div class="legend-item" v-for="item in title">
                <div class="legend-item-color" :style="'background: ' + item.color">
                </div>
                <div class="legend-item-name">
                  {{$t('calendar.'+item.field)}}
                </div>
              </div>
              <div class="legend-item">
                <div class="legend-item-color" style="background: #0091ff">
                </div>
                <div class="legend-item-name">
                  {{$t('common.today')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9 calendar-center">
        <div class="header row">
          <div class="col-xl-3 col-lg-12 font-20px" v-if="selected_mode == 'year'">
            <div class="pull-left">
              <i class="fa fa-angle-left circle-btn mr-15px" @click="backYear"></i>
              <div class="font-weight-600 calendar-text">{{full_date.format('YYYY')}}</div>
              <i class="fa fa-angle-right circle-btn ml-15px" @click="nextYear"></i>
            </div>
          </div>
          <div class="col-xl-5 col-lg-12 font-20px" v-if="selected_mode == 'month'">
            <div class="pull-left">
              <i class="fa fa-angle-left circle-btn mr-15px" @click="backMonth"></i>
              <div class="font-weight-600 calendar-text">{{$t('common.'+full_date.format('MMMM').toLowerCase())}} - {{full_date.format('YYYY')}}</div>
              <i class="fa fa-angle-right circle-btn ml-15px" @click="nextMonth"></i>
            </div>
          </div>
          <div class="col-xl-5 col-lg-12 font-20px" v-if="selected_mode == 'week'">
            <div class="pull-left">
              <i class="fa fa-angle-left circle-btn mr-15px" @click="backWeek"></i>
              <div class="font-weight-600 calendar-text">{{$t('common.'+full_date.format('MMMM').toLowerCase())}} - {{full_date.format('YYYY')}}</div>
              <i class="fa fa-angle-right circle-btn ml-15px" @click="nextWeek"></i>
            </div>
          </div>
          <div :class="(selected_mode == 'year' ? 'col-xl-9' : 'col-xl-7') + ' col-lg-12'">
            <button :class="'btn mode-btn pull-right border-radius-30px font-weight-600 ' + (mode != selected_mode ? 'bg-none' : 'bg-main')" v-for="mode in modes" :key="mode.id" @click="setMode(mode)">{{$t('common.'+mode)}}</button>
          </div>
        </div>
        <div class="full-width border-top"></div>
        <div class="body">
          <div class="" v-if="selected_mode == 'year'">
            <div class="row">
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{getSubtractMonth(5).format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="getSubtractMonth(5)" @setFullDate="setFullDate"></calendar-month-min>
              </div>
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{getSubtractMonth(4).format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="getSubtractMonth(4)" @setFullDate="setFullDate"></calendar-month-min>
              </div>
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{getSubtractMonth(3).format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="getSubtractMonth(3)" @setFullDate="setFullDate"></calendar-month-min>
              </div>
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{getSubtractMonth(2).format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="getSubtractMonth(2)" @setFullDate="setFullDate"></calendar-month-min>
              </div>
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{getSubtractMonth(1).format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="getSubtractMonth(1)" @setFullDate="setFullDate"></calendar-month-min>
              </div>
              <div class="col-lg-4">
                <div class="body-left-header">
                  <span class="font-weight-600 text-main text-left pl-10px uppercase">{{full_date.format('MMMM')}}</span>
                </div>
                <calendar-month-min :events="[]" :full_date="full_date" @setFullDate="setFullDate" :today="true" today-color="#0091ff"></calendar-month-min>
              </div>
            </div>
          </div>
          <div class="" v-if="selected_mode == 'month'">
            <calendar-month-full :events="[]" :full_date="full_date" @setFullDate="setFullDate" :today="true" today-color="#0091ff" :title="title" :data="data" @dataChange="dataChange"></calendar-month-full>
          </div>
          <div class="" v-if="selected_mode == 'week'">
            <calendar-week-full :events="[]" :full_date="full_date" @setFullDate="setFullDate" :today="true" today-color="#0091ff" :title="title" :data="data" @dataChange="dataChange"></calendar-week-full>
          </div>
        </div>
      </div>
      <div class="col-lg-3 body-right calendar-right pl-0" v-if="selected_mode == 'month' || selected_mode == 'week'">
        <div class="body-right-box">
          <div class="box-header">
            <div class="box-title">{{full_date.format('DD')}} {{$t('common.'+full_date.format('MMMM').toLowerCase())}}, {{full_date.format('YYYY')}}</div>
          </div>
          <div class="box-row">
            <div class="box-row-title">
              {{$t('calendar.event')}}
            </div>
            <div class="box-row-input dropdown-btn">
              <b-dropdown>
                <template slot="button-content">
                  <div class="legend-item-color" :style="'background: ' + selected_type.color">
                  </div>
                  <div class="legend-item-name">
                    {{$t('calendar.'+selected_type.field)}}
                  </div>
                </template>
                <b-dropdown-item v-for="item in title" :key="item.id" @click="setSelectedType(item)">
                  <div class="legend-item-color" :style="'background: ' + item.color">
                  </div>
                  <div class="legend-item-name">
                    {{$t('calendar.'+item.field)}}
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div v-for="(data, i) in selected_data[selected_type.field]" :key="i">
            <div class="box-row" v-if="selected_type.field == 'huts_day' || selected_type.field == 'public_holiday'" style="display: none">
              <div class="box-row-title">
                {{$t('common.active')}}
              </div>
              <div class="box-row-input pt-2">
                <label class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" v-bind:value="full_date.format('YYYY-MM-DD')" name="huts_day" @change="hutsDayChange" v-bind:checked="(full_date.format('YYYY-MM-DD') == selected_data[selected_type.field][i])">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
              </div>
            </div>
            <div class="box-row" v-if="selected_type.field == 'special_date_open' || selected_type.field == 'special_date_close'" >
              <div class="box-row-title">
                {{$t('calendar.title')}}
              </div>
              <div class="box-row-input">
                <b-form-input type="text" class="form-control border-radius-4px" v-model="selected_data[selected_type.field][i].name" />
              </div>
            </div>
            <hr v-if="i > 0" class="new-line"/>
            <div class="box-row" v-if="selected_type.field == 'special_date_open' || selected_type.field == 'special_date_close' || selected_type.field == 'order_duration'" :class="{ hide: selected_type.field == 'special_date_close' }">
              <div class="box-row-title">
                {{$t('calendar.time')}}
              </div>
              <div class="box-row-input">
                <div role="group" class="input-group">
                  <masked-input
                    type="text"
                    name="opening"
                    class="form-control col-lg-6 float-left border-radius-4px"
                    v-model="selected_data[selected_type.field][i].opening"
                    :mask="[/\d/, /\d/, ':', /\d/, /\d/]"
                    :guide="true"
                    placeholderChar="_"
                    :showMask="true"
                    :disabled="selected_type.field == 'order_duration' && checkConfig('time_settings_information', 'order_duration', 'disable')"
                    :keepCharPositions="true">
                  </masked-input>
                  <div class="input-group-append opacity-0">
                    <div class="input-group-text">

                    </div>
                  </div>
                  <masked-input
                    type="text"
                    name="closing"
                    class="form-control col-lg-6 float-left border-radius-4px"
                    v-model="selected_data[selected_type.field][i].closing"
                    :mask="[/\d/, /\d/, ':', /\d/, /\d/]"
                    :guide="true"
                    placeholderChar="_"
                    :showMask="true"
                    :disabled="selected_type.field == 'order_duration' && checkConfig('time_settings_information', 'order_duration', 'disable')"
                    :keepCharPositions="true">
                  </masked-input>
                  <div class="input-group-append" v-if="selected_type.field == 'order_duration' && selected_data[selected_type.field].length > 1">
                    <button type="button" class="btn btn-danger border-radius-4px" @click="removeSelectData(i)">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-row" v-if="selected_type.field == 'special_date_close'" :class="{ hide: selected_type.field == 'special_date_close' }">
              <div class="box-row-title">
                {{$t('calendar.all_day')}}
              </div>
              <div class="box-row-input pt-2">
                <label class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" name="full_day" @change="closeFullDay(i)" v-bind:checked="checkFullDay(i)">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
              </div>
            </div>
            <div class="box-row" v-if="selected_type.field == 'order_duration'">
              <div class="box-row-title">
                {{$t('common.delivery')}}
              </div>
              <div class="box-row-input">
                <b-input-group>
                  <b-form-select class="border-left-radius-4px"
                                 v-model="selected_data[selected_type.field][i].duration.D"
                                 :options="delivery_options[$session.get('lang')]"
                                 :disabled="checkConfig('time_settings_information', 'order_duration', 'disable')"
                                 @change="saveValueDelivery(selected_data[selected_type.field][i].duration.D)"
                                 />
                  <div class="input-group-append">
                    <b-input-group-append>
                      <b-btn class="border-right-radius-4px">{{$t('common.short_minute')}}</b-btn>
                    </b-input-group-append>
                  </div>
                </b-input-group>

              </div>
            </div>
            <div class="box-row" v-if="selected_type.field == 'order_duration'">
              <div class="box-row-title">
                {{$t('common.takeaway')}}
              </div>
              <div class="box-row-input">
                <b-input-group>
                  <b-form-select class="border-left-radius-4px"
                                 v-model="selected_data[selected_type.field][i].duration.C"
                                 :options="takeaway_options[$session.get('lang')]"
                                 :disabled="checkConfig('time_settings_information', 'order_duration', 'disable')"
                                 />
                  <div class="input-group-append">
                    <b-input-group-append>
                      <b-btn class="border-right-radius-4px">{{$t('common.short_minute')}}</b-btn>
                    </b-input-group-append>
                  </div>
                </b-input-group>
              </div>
            </div>
          </div>

        </div>
        <div class="body-right-action">
          <div class="row">
            <div class="col-4">
              <button class="btn btn-secondary save-btn " @click="addSelectData" v-if="selected_type.field == 'order_duration'">
                {{$t('common.add')}}
              </button>
            </div>
            <div class="col-4">
              <div class="btn  cancel-btn" @click="deleteData" v-if="checkNewData() == true && selected_type.field != 'public_holiday'">
                <i class="fa fa-trash-o"></i>
              </div>
            </div>
            <div class="col-4">
              <button class="btn btn-secondary save-btn" :disabled="submitting" @click="showNotification" v-if="selected_type.field != 'public_holiday'">
                {{$t('common.save')}}
              </button>
            </div>
          </div>
        </div>
        <div class="body-right-legend pl-20px">
          <div class="body-left-legend-title">
            {{$t('calendar.categories')}}
          </div>
          <div class="body-left-legend-body">
            <div class="legend-item" v-for="item in title">
              <div class="legend-item-color" :style="'background: ' + item.color">
              </div>
              <div class="legend-item-name">
                {{$t('calendar.'+item.field)}}
              </div>
            </div>
            <div class="legend-item">
              <div class="legend-item-color" style="background: #0091ff">
              </div>
              <div class="legend-item-name">
                {{$t('common.today')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="notification" ref="notification" hide-footer v-bind:title="$t('store.notification')" >
      <p class="calendar-notification" v-html="$t('store.alert_content')"></p>
      <p>{{$t('store.alert_title')}}</p>
      <div class="row">
        <span class="col-md-3">{{$t('store.alert_phone_title_1')}}</span>
        <span class="ml-20px">{{$t('store.alert_phone_number_1')}}</span>
      </div>
      <div class="row ">
        <span class="col-md-3">{{$t('store.alert_phone_title_2')}}</span>
        <span class="ml-20px">{{$t('store.alert_phone_number_2')}}</span>
      </div>
<!--      <div class="row ">-->
<!--        <span class="col-md-3">{{$t('store.alert_phone_title_3')}}</span>-->
<!--        <span class="ml-20px">{{$t('store.alert_phone_number_3')}}</span>-->
<!--      </div>-->
      <div>

        <button type="button" @click="saveSelectedData" class="btn btn-primary" style="background:#0086FF !important; background-color: #0086FF !important; border-radius: 3px; float: right;">{{$t('common.ok')}}</button>
        <button type="button" @click="closeNotification" class="btn" style="border-radius: 3px; float: right;margin-right: 15px;">{{$t('common.cancel')}}</button>
      </div>
    </b-modal>
  </div>

</template>

<style>
  .ml-20px {
    margin-left: 20px;
  }
  #notification .modal-dialog {
    width: 50% !important;
    min-width: 500px;
  }
  #calendar .calendar-text {
    width: 170px;
    text-align: center;
    float: left;
    line-height: 25px;
  }
  #calendar .font-20px {
    font-size: 20px;
  }
  #calendar .font-weight-600 {
    font-weight: 600;
  }
  #calendar .mr-15px {
    margin-right: 15px;
  }
  #calendar .ml-15px {
    margin-left: 15px;
  }
  #calendar .pr-0 {
    padding-right: 0;
  }
  #calendar .pl-10px {
    padding-left: 10px;
  }
  #calendar .uppercase {
    text-transform: uppercase;
  }
  #calendar .m-0 {
    margin: 0;
  }
  #calendar .mt-5px {
    margin-top: 5px;
  }
  #calendar .mt-20px {
    margin-top: 20px;
  }
  #calendar .mb-0 {
    margin-bottom: 0;
  }
  #calendar .pl-0 {
    padding-left: 0;
  }
  #calendar .pl-20px {
    padding-left: 20px;
  }
  #calendar .px-25px {
    padding-left: 25px;
    padding-right: 25px;
  }
  #calendar .py-15px {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #calendar .opacity-0 {
    opacity: 0
  }
  #calendar .border-radius-4px {
    border-radius: 4px;
  }
  #calendar .border-left-radius-4px {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  #calendar .border-right-radius-4px {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  #calendar .border-radius-30px {
    border-radius: 30px;
  }
  #calendar .calendar-left {
    padding-right: 0px;
    display: flex;
    flex-direction: column;
  }
  #calendar .calendar-center {
    padding-left: 0px;
    padding-right: 0px;
  }
  #calendar .calendar-right {
    padding-left: 0px;
  }
  #calendar .bg-main {
    background: #0091ff;
    color: #fff !important;
  }
  #calendar .text-main {
    color: #0091ff;
  }
  #calendar .bg-none {
    background: none;
  }
  #calendar .main-container {
    background: #fff;
    box-shadow: 0px 0px 10px #bfbbbb;
    border-radius: 2px;
    padding: 10px;
    min-height: 30px;
  }
  #calendar .header {
    line-height: 35px;
    min-height: 45px;
  }
  #calendar .body {
    flex: 1;
  }
  #calendar .circle-btn {
    border-radius: 50%;
    border: 1px solid #9fa1a3;
    color: #9fa1a3;
    cursor: pointer;
    width: 25px;
    height: 25px;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
    float: left;
  }
  #calendar .close-btn {
    color: #9fa1a3;
    font-size: 25px;
    line-height: 25px;
    margin-right: 15px;
    margin-left: 25px;
    margin-top: 5px;
    cursor: pointer;
  }
  #calendar .close-btn .fa-angle-right {
    margin-right: -5px;
  }
  #calendar .close-btn .fa-angle-left {
    margin-left: -5px;
  }
  #calendar .create-btn {
    padding: 10px 25px;
  }
  #calendar .mode-btn {
    padding: 5px 17px;
    margin: 7px 10px;
    color: #9fa1a3;
  }
  #calendar .border-top {
    border-top: 1px solid #e3e4e9 !important;
  }
  #calendar .body-left {
    border-right: 1px solid #e3e4e9;
    padding-right: 0px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
  }
  #calendar .body-left-box {
    flex: 1;
  }
  #calendar .body-left-legend {
    height: 250px;
  }
  #calendar .body-left-header {
    display: flex;
    line-height: 20px;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  #calendar .body-left-header span{
    flex: 1;
    text-align: center;
  }
  #calendar .body-left-header .fa-angle-right {
    width: 15px;
    line-height: 20px;
    color: #9fa1a3;
    cursor: pointer;
  }
  #calendar .body-left-header .fa-angle-left {
    width: 15px;
    line-height: 20px;
    color: #9fa1a3;
    cursor: pointer;
  }
  #calendar .body-left-legend-title {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
  }
  #calendar .body-left-legend-body {
    width: 100%;
  }
  #calendar .legend-item {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
    height: 25px;
  }
  #calendar .legend-item-color {
    margin-top: 2px;
    margin-right: 10px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    float: left;
  }
  #calendar .legend-item-name {
    height: 20px;
    line-height: 15px;
    font-size: 14px;
    color: #94969b;
    overflow: hidden;
  }
  #calendar .body-right {
    display: flex;
    flex-direction: column;
  }
  #calendar .body-right-box {
    flex: 1;
    background: #5e4cdd;
    border: 1px solid #5e4cdd;
  }
  #calendar .body-right-legend {
    height: 250px;
  }
  #calendar .box-header {
    display: flex;
    color: #fff;
    font-weight: 600;
    margin-bottom: 20px;
  }
  #calendar .box-header .box-title {
    flex: 1;
    padding-left: 20px;
    font-size: 17px;
    margin-top: 20px;
  }
  #calendar .box-header .box-close {
    margin-top: 20px;
    margin-right: 20px;
    height: 30px;
    font-size: 20px;
    cursor: pointer;
  }
  #calendar .dropdown-btn .legend-item-name {
    font-size: 13px;
    line-height: 17px;
  }
  #calendar .box-row {
    width: 100%;
    color: #fff;
    font-weight: 600;
    margin-bottom: 20px;
    height: 40px;
  }
  #calendar .box-row .box-row-title {
    width: 30%;
    float: left;
    padding-left: 20px;
    line-height: 40px;
    font-size: 14px;
    height: 40px;
    overflow: hidden;
  }
  #calendar .box-row .box-row-input {
    width: 70%;
    float: left;
    padding-right: 20px;
  }
  #calendar .box-row-input .b-dropdown {
    width: 100%;
  }
  #calendar .box-row-input .dropdown-toggle {
    width: 100%;
    text-align: left;
    height: 40px;
    background: #fff;
    border-radius: 4px;
  }
  #calendar .box-row-input .dropdown-toggle:hover {
    background: #ebebeb;
  }
  #calendar .box-row-input .dropdown-toggle::after {
    display: block !important;
    margin-left: calc(100% - 40px);
    height: 40px;
    position: absolute;
    top: 17px;
    font-size: 30px;
    color: #7d7f85;
  }
  #calendar .box-row-input .b-dropdown .dropdown-menu {
    width: 100%;
  }
  #calendar .switch-primary > .switch-input:checked ~ .switch-label {
    background: #0091ff !important;
    border-color: #1985ac;
  }
  #calendar .body-right-action {
    height: 55px;
    background: #5e4cdd;
    border: 1px solid #5e4cdd;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 15px;
  }
  #calendar .body-right-action .save-btn {
    width: 80px;
    color: #0091ff;
    border-radius: 4px;
    line-height: 25px;
    font-weight: 600;
    font-size: 15px;
    background: #fff;
  }
  #calendar .body-right-action .cancel-btn {
    width: 80px;
    color: #fff;
    border-radius: 4px;
    line-height: 25px;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
  }
  .new-line {
    border-top: 1.5px solid white;
  }
</style>
<script>
import CalendarMonthMin from './CalendarMonthMin.vue'
import CalendarMonthFull from './CalendarMonthFull.vue'
import CalendarWeekFull from './CalendarWeekFull.vue'
import MaskedInput from 'vue-text-mask'
import cSwitch from '../Switch'

export default {
  name: 'Calendar',
  components: {
    CalendarMonthMin,
    CalendarMonthFull,
    CalendarWeekFull,
    MaskedInput,
    cSwitch
  },
  props: {
    value: {
      required: false
    },
    events: {
      required: false
    },
    mode: {
      type: String,
      required: false,
      default: 'month'
    },
    submitting: false
  },
  data: function () {
    return {
      full_date: this.$moment(),
      weeks: [],
      modes: [
        // 'year',
        'month',
        'week',
        // 'day'
      ],
      selected_mode: '',
      selected_type: {},
      options_type: [],
      delivery_options: {},
      takeaway_options: {},
      selected_data: {},
      text_delivery: '',
      text_event: '',
      title: {
        order_duration: {
          name: 'Order Duration',
          field: 'order_duration',
          color: '#4fd7dd'
        },
        special_date_open: {
          name: 'Special Day (Open)',
          field: 'special_date_open',
          color: '#5e4cdd'
        },
        special_date_close: {
          name: 'Special Day (Close)',
          field: 'special_date_close',
          color: '#bab2f0'
        },
        huts_day: {
          name: 'Hut\'s Day',
          field: 'huts_day',
          color: '#d14545'
        },
        public_holiday: {
          name: 'Public Holiday',
          field: 'public_holiday',
          color: '#e5a12d'
        }
      },
      data: {}
    }
  },
  methods: {
    backYear () {
      this.full_date = this.$moment(this.full_date).subtract('1', 'year')
    },
    nextYear () {
      this.full_date = this.$moment(this.full_date).add('1', 'year')
    },
    setMode (mode) {
      this.selected_mode = mode
    },
    backWeek () {
      this.full_date = this.$moment(this.full_date).subtract('1', 'week')
    },
    nextWeek () {
      this.full_date = this.$moment(this.full_date).add('1', 'week')
    },
    backMonth () {
      this.full_date = this.$moment(this.full_date).subtract('1', 'month')
    },
    nextMonth () {
      this.full_date = this.$moment(this.full_date).add('1', 'month')
    },
    setFullDate (date) {
      this.full_date = date
    },
    getSubtractMonth (num) {
      let date = this.$moment(this.full_date)
      return date.startOf('month').subtract(num, 'month')
    },
    setSelectedType (type) {
      this.selected_type = type
      this.text_event = type.field
    },
    dataChange (data) {
      if (!this.checkConfig('time_settings_information', 'order_duration', 'show')) {
        delete data.order_duration
      } else {
        if (data['order_duration'] == null) {
          data['order_duration'] = [{
            date: this.full_date.format('YYYY-MM-DD'),
            opening: '08:00',
            closing: '22:00',
            duration: {
              D: 30,
              C: 10
            },
            name: '',
            new: true
          }]
        }
      }
      if (data['special_date_open'] == null) {
        data['special_date_open'] = [{
          date: this.full_date.format('YYYY-MM-DD'),
          opening: '__:__',
          closing: '__:__',
          name: '',
          new: true
        }]
      }
      if (data['special_date_close'] == null) {
        data['special_date_close'] = [{
          date: this.full_date.format('YYYY-MM-DD'),
          opening: '08:00',
          closing: '22:00',
          name: '',
          new: true
        }]
      }
      if (data['huts_day'] == null) {
        data['huts_day'] = [null]
      }
      if (data['public_holiday'] == null) {
        data['public_holiday'] = [null]
      }
      this.selected_data = this._.cloneDeep(data)
      let exist = false
      let firstType = {}
      for (let i in data) {
        firstType = this.title[i]
        if (this.selected_type != null && this.title[i].field == this.selected_type.field) {
          exist = true
          break
        }
      }

      if (!exist) {
        this.selected_type = firstType
      }
    },
    closeFullDay (index) {
      this.selected_data['special_date_close'][index]['opening'] = '00:00'
      this.selected_data['special_date_close'][index]['closing'] = '23:59'
    },
    checkFullDay (index) {
      if (this.selected_data['special_date_close'][index]['opening'] == '00:00' && this.selected_data['special_date_close'][index]['closing'] == '23:59') {
        return true
      }
      return false
    },
    closeNotification() {
      this.$refs.notification.hide()
    },
    saveValueDelivery(value){
      this.text_delivery = value
    },
    showNotification () {
      if(( this.text_delivery == 45 || this.text_delivery == 60 || this.text_delivery == -1 || this.text_event === "special_date_close") && this.outlet_config.config.warning_calendar && this.$store.getters.config.gms.base.calendar_notification) {
        this.$refs.notification.show()
      }else{
        this.saveSelectedData()
      }
    },
    hutsDayChange (val) {
      let hutsDays = []
      if (!val.target.checked) {
        for (let i in this.selected_data['huts_day']) {
          if (this.selected_data['huts_day'][i] != val.target.value && this.selected_data['huts_day'][i] != null) {
            hutsDays.push(this.selected_data['huts_day'][i])
          } else {
            if (this.selected_data['huts_day'][i] == val.target.value) {
              hutsDays.push(null)
            }
          }
        }
      } else {
        let exist = false
        for (let i in this.selected_data['huts_day']) {
          if (this.selected_data['huts_day'][i] == val.target.value) {
            exist = true
          }
        }
        for (let i in this.selected_data['huts_day']) {
          if (this.selected_data['huts_day'][i] != null) {
            hutsDays.push(this.selected_data['huts_day'][i])
          }
        }
        if (!exist) {
          hutsDays.push(val.target.value)
        }
      }
      this.selected_data['huts_day'] = this._.cloneDeep(hutsDays)
    },
    clearSelectedData () {
      this.selected_data = {}
    },
    saveSelectedData () {
      switch (this.selected_type.field) {
        case 'huts_day':
          let exist = false
          for (let j in this.data[this.selected_type.field]) {
            if (this.data[this.selected_type.field][j] == this.full_date.format('YYYY-MM-DD')) {
              exist = true
            }
          }
          if (!exist) {
            this.data[this.selected_type.field].push(this.full_date.format('YYYY-MM-DD'))
          }
          break
        default:
          let data = []
          
          for (let j in this.data[this.selected_type.field]) {
            if (this.data[this.selected_type.field][j].date != this.full_date.format('YYYY-MM-DD')) {
              data.push(this.data[this.selected_type.field][j])
            }
          }
          for (let k in this.selected_data[this.selected_type.field]) {
            delete this.selected_data[this.selected_type.field][k].new
            data.push(this.selected_data[this.selected_type.field][k])
          }
          
          if(this.selected_type.field === "special_date_open") {
            if ( data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                if ((data[i].opening == "__:__" || data[i].closing == "__:__") || data[i].opening > data[i].closing) {
                  this.$toastr.error(this.$t('message.from_to_time_invalid'), this.$t('calendar.special_date_open'), {})
                  return
                }
              }
            }
          }
          this.data[this.selected_type.field] = data
          
      }
      let flag = true
      for (let t in this.selected_data) {
        if (this._.indexOf(['huts_day', 'public_holiday'], t) < 0) {
          let _data = this.selected_data[t][0]
          if (_data.opening > _data.closing) {
            flag = false
            this.$toastr.error(this.$t('message.from_to_time_invalid'), this.$t('calendar.' + t), {})
          }
        }
      }
      if (!flag) {
        return
      }

      this.$emit('input', this.data)
      this.$emit('change', this.data)
      this.closeNotification()
    },
    convertTime (time) {
      if (time && time.length <= 5) {
        time += ':00'
      }
      return time
    },
    checkNewData () {
      for (let i in this.selected_data[this.selected_type.field]) {
        // Hard code for hut's day checking, need to improve
        if (typeof this.selected_data[this.selected_type.field][i] == 'string' || this.selected_data[this.selected_type.field][i] == null) {
          if (this.selected_data[this.selected_type.field][i] != null) {
            return true
          }
        } else {
          if (this.selected_data[this.selected_type.field][i].new != true) {
            return true
          }
        }
      }
      return false
    },
    deleteData () {
      for (let i in this.selected_data[this.selected_type.field]) {
        let newData = []
        for (let j in this.data[this.selected_type.field]) {
          // Hard code for hut's day checking, need to improve
          if (typeof this.selected_data[this.selected_type.field][i] == 'string' || this.selected_data[this.selected_type.field][i] == null) {
            if (this.data[this.selected_type.field][j] != this.full_date.format('YYYY-MM-DD')) {
              newData.push(this.data[this.selected_type.field][j])
            }
          } else {
            if (this.data[this.selected_type.field][j].date != this.full_date.format('YYYY-MM-DD')) {
              newData.push(this.data[this.selected_type.field][j])
            }
          }
        }
        this.data[this.selected_type.field] = this._.cloneDeep(newData)
        this.$emit('input', this.data)
        this.$emit('change', this.data)
        return
      }
    },
    checkConfig (key, value, category) {
      this.outlet_config = this.$store.getters.config.gms.outlet
      let vm = this
      if (typeof this.$route.params.uuid === 'undefined') {
        if (category === 'show') {
          return true
        } else {
          return false
        }
      }
      if (typeof vm.outlet_config[key] !== 'undefined') {
        let result = vm.outlet_config[key].filter(obj => {
          return obj.type === value
        })
        if (typeof result[0] !== 'undefined') {
          return result[0][category]
        }
      }
    },
    addSelectData () {
      if (this.selected_type.field == 'order_duration') {
        this.selected_data[this.selected_type.field].push({
          date: this.full_date.format('YYYY-MM-DD'),
          opening: '08:00',
          closing: '22:00',
          duration: {
            D: 30,
            C: 10
          },
          name: '',
          new: true
        })
      }
    },
    removeSelectData (index) {
      if (this.selected_type.field == 'order_duration') {
        let data = []
        for (let i in this.selected_data[this.selected_type.field]) {
          if (i != index) {
            data.push(this.selected_data[this.selected_type.field][i])
          }
        }
        this.selected_data[this.selected_type.field] = data
      }
    }
  },
  filters: {
    minDayOfWeek: function (day) {
      return day.substr(0, 3).toUpperCase()
    }
  },
  created () {
    this.selected_mode = this.mode
    this.data = this.value
    
    const firstDeliveryOption = [
        {text: 45, value: 45},
        {text: 60, value: 60}]
  
    let deliveryOptions;

    if (this.isJapanMarket()) {
      const specificDayOff = '2030-01-01'
      const tz = this.client_tz.jp
      const startDate = this.$moment.utc(this.$moment()).tz(tz)
      const endDate = this.$moment.utc(this.$moment(specificDayOff)).tz(tz)
      const validDate = startDate.diff(endDate, 'days') < 0
      deliveryOptions = (this.checkConfig('time_settings_information', 'delivery_time', 'show') && validDate) ? firstDeliveryOption : []
    } else {
      deliveryOptions = !this.checkConfig('time_settings_information', 'delivery_time', 'show') ? firstDeliveryOption : []
    }
    
    //delivery_options
    let langs = Object.keys(this.$i18n.messages)
    for (let l in langs) {
      this.delivery_options[langs[l]] = [
        {text: 15, value: 15},
        {text: 30, value: 30},
        ...deliveryOptions,
        {text: this.$t('calendar.stop_order', langs[l]), value: -1}
      ]
      this.takeaway_options[langs[l]] = [
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 30, value: 30},
        {text: 40, value: 40},
        {text: 50, value: 50},
        {text: 60, value: 60},
        {text: this.$t('calendar.stop_order', langs[l]), value: -1}
      ]
    }

    if (!this.checkConfig('time_settings_information', 'order_duration', 'show')) {
      delete this.title['order_duration']
    }
  },
  watch: {
    full_date: function (val) {
      for (let i in this.selected_data) {
        for (let j in this.selected_data[i]) {
          if (i == 'huts_day' || i == 'public_holiday') {
            if (this.selected_data[i][j] != null) {
              this.selected_type = this.title[i]
            }
          } else {
            if (this.selected_data[i][j] != null && this.selected_data[i][j].new == null) {
              this.selected_type = this.title[i]
            }
          }
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/Calendar.vue